// ---------------------------------------------------------------------------
// Constantes da listagem de movimentos (/movements).
// ---------------------------------------------------------------------------

// Porte da página. Eram 15 linhas fixas até 2026-09-12; o protótipo trouxe o
// seletor de linhas, e 25 entrou como default (10 seria uma regressão de
// densidade para quem já operava com 15).
export const PER_PAGE_OPTIONS = [10, 25, 50];
export const DEFAULT_PER_PAGE = 25;

// ⚠️ Diferente do padrão BillingCharges/ClienteList, a ordenação aqui é
// CLIENT-SIDE: o `POST /movement-search` devolve a lista inteira do filtro,
// sem `order_by`/`page`. Esta whitelist NÃO espelha contrato de backend — são
// as chaves de UI ordenáveis em memória, e ela serve para validar o que vem da
// URL. O §1.10 do navegacao.md não se aplica como contrato: não há ordenação
// fantasma, o sort acontece de verdade no cliente.
export const SORTABLE_KEYS = new Set([
   'id',
   'pdv',
   'user',
   'move_type',
   'doc_type',
   'doc_number',
   'created_at',
   'movement_flag',
]);

export const MOVE_TYPE_SEGMENTS = [
   { value: '', label: 'Todos' },
   { value: 'in', label: 'Entradas' },
   { value: 'out', label: 'Saídas' },
];

// `movement_flag` é ENUM no backend (`confirmed|deleted|reversion`) desde
// 2026-08-16. O protótipo previa "Pendentes", estado que NÃO existe no
// domínio — oferecê-lo seria filtro fantasma. `reversion` também fica fora: a
// reversão é o movimento-espelho que o backend cria ao excluir, não um estado
// que a operação pesquisa (a exclusão já aparece como EXCLUÍDO).
export const STATUS_SEGMENTS = [
   { value: '', label: 'Todos' },
   { value: 'confirmed', label: 'Confirmados' },
   { value: 'deleted', label: 'Excluídos' },
];

export const STATUS_FILTER_LABEL = {
   confirmed: 'Confirmado',
   deleted: 'Excluído',
};

// Atalhos de período: contagem de dias INCLUINDO hoje (7 dias = hoje e os 6
// anteriores). Só preenchem as datas — a busca continua explícita.
export const PERIOD_SHORTCUTS = [
   { key: 'hoje', label: 'Hoje', days: 1 },
   { key: '7d', label: '7 dias', days: 7 },
   { key: '14d', label: '14 dias', days: 14 },
   { key: '30d', label: '30 dias', days: 30 },
];
